import axios from 'axios';

// URL provided by user
const WEBHOOK_URL = 'https://automatizacion.aigencia.ai/webhook/facial-recognition';

/**
 * Sends a base64 image to the n8n facial recognition webhook.
 * @param {string} base64Image - The image to send (including data:image/jpeg;base64 prefix or raw base64)
 * @returns {Promise<Object>} - The n8n response data
 */
export const identifyUser = async (base64Image) => {
    try {
        // n8n binary input usually expects the raw file or a specific JSON structure depending on the node.
        // Based on the "Code" node logic in `Toni - Ateneu App.json`, it handles multiple formats (binary, json.image, etc.)
        // We will send it as a JSON payload which is easiest via axios.
        // The "Code" node has a check for: if ($input.first().json && $input.first().json.image ...)

        const payload = {
            image: base64Image
        };

        const response = await axios.post(WEBHOOK_URL, payload, {
            headers: {
                'Content-Type': 'application/json'
            }
        });

        return response.data;
    } catch (error) {
        console.error('Error calling facial recognition webhook:', error);
        throw error;
    }
};
